module.exports = __webpack_public_path__ + "static/media/tier-8.baac9134.jpg";